export enum ContactRoleAccessLevel {
  FULL_ACCESS = 'Full Access',
  VIEW_ACCESS = 'View Access',
}
